
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { UsersModel } from 'common/models/page-models/users/user-data-model';
import { UsersGridMetaModel } from 'common/models/page-models/users/users-grid-meta-model';
import { UsersListingModel } from 'common/models/page-models/users/users-grid-model';
import { UsersGridDataService } from 'common/services/data-services/admin/user/users-grid-data.services';


 
@Injectable({
    providedIn: 'root'
})
export class UsersGridWidgetService extends GridWidgetService<UsersModel, UsersListingModel> {
    constructor(protected override ds: UsersGridDataService, protected systemService: SystemService) {
        super(ds);
    }
 
    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }
 
    getMetaModel(): MetaModel {
        const meta = new UsersGridMetaModel().getMetaModel();
        return meta;
    }
}